export const seamlessConstant = {
    CHECK_SEAMLESS: 'CHECK_SEAMLESS',
    GET_MEMBER_WALLET: 'GET_MEMBER_WALLET',
    SHOW_TOTAL_BALANCE_DETAILS: 'SHOW_TOTAL_BALANCE_DETAILS',
    IS_APPLYING_PROMOTION_ID: 'IS_APPLYING_PROMOTION_ID',
    GET_SEAMLESS_ALL_PROVIDER_WALLETS: 'GET_SEAMLESS_ALL_PROVIDER_WALLETS',
    UPDATE_SEAMLESS_PROVIDER_WALLETS: 'UPDATE_SEAMLESS_PROVIDER_WALLETS',
    GET_TOTAL_TRANSFER_WALLET_BALANCE: 'GET_TOTAL_TRANSFER_WALLET_BALANCE',
    GET_SEAMLESS_PROMOTION_QUEUE_DATA: 'GET_SEAMLESS_PROMOTION_QUEUE_DATA',
    IS_SEAMLESS_PROMOTION_EXIST: 'IS_SEAMLESS_PROMOTION_EXIST',
    SEAMLESS_PROMOTION_DATA: 'SEAMLESS_PROMOTION_DATA',
    GET_TRANSFER_WALLET: 'GET_TRANSFER_WALLET',
    UPDATE_SEAMLESS_TRANSFER_WALLETS: 'UPDATE_SEAMLESS_TRANSFER_WALLETS',
    UPDATE_SELECTED_SEAMLESS_PROMO_ID: 'UPDATE_SELECTED_SEAMLESS_PROMO_ID',
    UPDATE_SEAMLESS_PROMO_LIST: 'UPDATE_SEAMLESS_PROMO_LIST',
    UDPATE_LOAD_WALLET: 'UDPATE_LOAD_WALLET',
    SET_SEAMLESS_FETCH_STATUS: 'SET_SEAMLESS_FETCH_STATUS',
};
